package kz.dentalcrm.app.theme

import androidx.compose.runtime.compositionLocalOf
import kz.dentalcrm.app.core.ui.window.WindowSize

val LocalWindowSize = compositionLocalOf { WindowSize.COMPACT }